import { IEventStatus } from '../entities/IEventStatus';
import { httpClient } from './helper/httpClient';

class EventStatusService {
  private _baseURL = 'event-status';

  getAll(options?: {
    archived?: 'only' | 'include' | 'exclude';
  }): Promise<IEventStatus[]> {
    return httpClient.get<null, IEventStatus[]>(this._baseURL, {
      params: options?.archived ? { archived: options.archived } : undefined,
    });
  }

  create(data: {
    name: string;
    color?: string;
    icon?: string;
  }): Promise<IEventStatus> {
    return httpClient.post<null, IEventStatus>(this._baseURL, data);
  }

  update(
    id: string,
    data: { name?: string; color?: string; icon?: string },
  ): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, data);
  }

  delete(id: string, reassignToStatusId?: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`, {
      data: reassignToStatusId ? { reassignToStatusId } : undefined,
    });
  }

  reorder(statusIds: string[]): Promise<void> {
    return httpClient.put(`${this._baseURL}/reorder`, { statusIds });
  }

  restore(id: string): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}/restore`);
  }
}

export default new EventStatusService();
